import QuotaInformation from '../pages/QuotaInformation';

export const quotaInformationRoutePage = {
  component: <QuotaInformation />,
  route: '/informacoes-de-cotas',
};
